module.exports = __webpack_public_path__ + "static/logo-4f87cdc9b3dda1ad37f50665271cf5ee.svg";